// extracted by mini-css-extract-plugin
module.exports = {"container":"y0Q919bmQefpeiiZQMyUs","secure":"_3N5W1u1u-FdedsHOV87jkD","secureText":"_38acc5MJuh-Kz_u-go1RTD","logo":"_1LfKMrZHkYM7vKlGasCIZx"};